// extracted by mini-css-extract-plugin
export default {"imagesContainer":"dl_dj","column":"dl_k2","leftImage":"dl_lP","image":"dl_dx"};